import Podplistic from '../assets/images/podplistic/thumbnail.png';

const ProjectData = [
    {
        id: "podplistic",
        image: Podplistic,
        alt:"Screenshot of podplistic's website",
        title:"The Future of Podcasts",
        description:"Podplistic",
        link: "/case-study/podplistic",
    }
]

export default ProjectData;